export default {
  title: 'Download the foundation package',
  select: 'Please select quality',
  lowQuality: 'Low quality',
  middleQuality: 'Medium quality',
  highQuality: 'High quality',
}
